// extracted by mini-css-extract-plugin
export default {"wrapper":"home-page_wrapper__GZw7M","title":"home-page_title__sFcTc"};